import { NgModule, ErrorHandler } from '@angular/core';
import { DebugComponent } from './debug.component';
import { CommonModule } from '@angular/common';
import { DebugService } from './debug.service';
import { IonicModule } from '@ionic/angular';
import { DebugRoutingModule } from './debug.routing';
import { DebugPanelModule } from './debug-panel.module';
import { ErrorLogger } from './error-logger';
import { TranslateModule } from '@ngx-translate/core';
import { PageLayoutModule } from '../page-layout';

@NgModule({
    declarations: [DebugComponent],
    exports: [DebugComponent],
    imports: [CommonModule, IonicModule, DebugRoutingModule, DebugPanelModule, TranslateModule, PageLayoutModule],
    providers: [DebugService, Clipboard, { provide: ErrorHandler, useClass: ErrorLogger }]
})
export class DebugModule {}
